import { createPortal } from 'react-dom'
import { Tooltip as ReactTooltip } from 'react-tooltip'

interface TooltipProps {
	readonly children: React.ReactNode;
	readonly anchor: string;
	readonly openOnClick?: boolean | undefined;
	readonly arrow?: boolean | undefined;
	readonly defaultPlace?: 'top' | 'right' | 'bottom' | 'left' | undefined;
	readonly offset?: number | undefined;
	readonly customWidth?: string | undefined;
}

export default function Tooltip({
	children,
	anchor,
	openOnClick = false,
	arrow = true,
	defaultPlace = 'top',
	offset,
	customWidth = 'max-w-[300px]'
}: TooltipProps) {
	const tooltipContent = (
		<ReactTooltip
			disableStyleInjection
			className={ `z-50 break-words bg-black text-white py-2 px-4 rounded-md text-sm ${customWidth}` }
			anchorSelect={ `[data-tooltip='${anchor}']` }
			openOnClick={ openOnClick }
			noArrow={ !arrow }
			place={ defaultPlace }
			offset={ offset }
		>
			{ children }
		</ReactTooltip>
	)

	return createPortal(tooltipContent, document.body)
}

